export default __webpack_public_path__ + "static/media/pineapple.a01ab9be.jpg";